/* AirRobe "Your stylist" launcher behaviour (snippets/aire-launcher.liquid, aire-launcher.css).
   Spec: the AIRE "Your Stylist launcher" artifact.
   - Desktop: engages on hover (CSS), opens on click.
   - Touch: engages on finger-down, opens on release + 170ms (the lift is the press feedback).
   - The pill stays engaged while the panel is open and settles when it closes.
   - Lightbox: one pill directly under the enlarged image. The lightbox stays open behind the
     panel, and its arrow/Esc keys are switched off while the panel is open (they'd otherwise
     change images or close the lightbox while the shopper types in the chat).
   Opening itself is the AIRE block's own delegated click on [data-aire-stylist-open]. */
(function () {
  if (window.AireLauncher) return;

  var OPEN_DELAY = 170;
  var GAP_UNDER_IMAGE = 8;
  var touch = window.matchMedia('(hover: none), (pointer: coarse)');
  var desktop = window.matchMedia('(min-width: 1068px)');

  // The block moves its overlay into a shadow root on a <body> child once it initialises.
  function overlay() {
    var host = document.querySelector('[data-airrobe-fit-finder-host]');
    var scope = (host && host.shadowRoot) || document;
    return scope.querySelector('[data-airrobe-fit-finder-overlay]');
  }

  function panelOpen() {
    var el = overlay();
    return !!el && !el.hidden;
  }

  function settle() {
    document.querySelectorAll('.aire-launcher.is-active').forEach(function (pill) {
      pill.classList.remove('is-active');
    });
  }

  // Keep the pill engaged until the panel closes (the overlay gets `hidden` back).
  function settleWhenPanelCloses() {
    var el = overlay();
    if (!el || !window.MutationObserver) return settle();
    var observer = new MutationObserver(function () {
      if (el.hidden) {
        observer.disconnect();
        settle();
      }
    });
    observer.observe(el, { attributes: true, attributeFilter: ['hidden'] });
  }

  document.addEventListener('pointerdown', function (event) {
    var pill = event.target.closest('.aire-launcher');
    if (pill && event.pointerType !== 'mouse') pill.classList.add('is-active');
  });

  ['pointercancel', 'pointerleave'].forEach(function (type) {
    document.addEventListener(
      type,
      function (event) {
        var pill = event.target.closest && event.target.closest('.aire-launcher');
        if (pill && !pill.dataset.aireOpening && !panelOpen()) pill.classList.remove('is-active');
      },
      true
    );
  });

  // Capture phase on window, so this runs before the block's document-level open handler.
  window.addEventListener(
    'click',
    function (event) {
      var pill = event.target.closest('.aire-launcher');
      if (!pill) return;
      pill.classList.add('is-active');
      if (!event.isTrusted || !touch.matches) {
        if (event.isTrusted) settleWhenPanelCloses();
        return;
      }
      // Touch: hold the open for 170ms, then re-click (untrusted, so it passes straight through).
      event.preventDefault();
      event.stopPropagation();
      if (pill.dataset.aireOpening) return;
      pill.dataset.aireOpening = 'true';
      window.setTimeout(function () {
        delete pill.dataset.aireOpening;
        pill.click();
        settleWhenPanelCloses();
      }, OPEN_DELAY);
    },
    true
  );

  function lightboxPill(pswpElement) {
    var pill = pswpElement && pswpElement.querySelector('.aire-launcher--lightbox');
    return pill && getComputedStyle(pill).display !== 'none' ? pill : null;
  }

  // Room above (counter/close) and below (gap + pill + breathing room) the enlarged image.
  function bars() {
    return desktop.matches ? { top: 100, bottom: GAP_UNDER_IMAGE + 58 + 40 } : { top: 68, bottom: GAP_UNDER_IMAGE + 38 + 56 };
  }

  window.AireLauncher = {
    // Extra PhotoSwipe options, or null when the launcher isn't on this page.
    lightboxOptions: function (pswpElement) {
      if (!lightboxPill(pswpElement)) return null;
      return {
        barsSize: bars(),
        fitControlsWidth: 0, // keep the bars on touch screens too, so the pill fits under the image
        isClickableElement: function (el) {
          return el.tagName === 'A' || !!el.closest('.aire-launcher');
        },
      };
    },

    attachLightbox: function (gallery, pswpElement) {
      var pill = lightboxPill(pswpElement);
      if (!pill) return;

      // Same fit as PhotoSwipe ('fit', never upscaled). The pill sits under the tallest image of
      // the set, so it never moves between images (with this store's same-size shots that's
      // directly under every image).
      function place() {
        var vp = gallery.viewportSize;
        var b = gallery.options.barsSize;
        var area = vp.y - b.top - b.bottom;
        var bottom = 0;
        gallery.items.forEach(function (item) {
          if (!item.w || !item.h) return;
          var zoom = Math.min(vp.x / item.w, area / item.h, 1);
          var h = item.h * zoom;
          bottom = Math.max(bottom, b.top + (area - h) / 2 + h);
        });
        pill.style.top = Math.round((bottom || vp.y - b.bottom) + GAP_UNDER_IMAGE) + 'px';
      }

      function guardKeys() {
        if (!panelOpen()) return;
        var options = gallery.options;
        var arrowKeys = options.arrowKeys;
        var escKey = options.escKey;
        options.arrowKeys = false;
        options.escKey = false;
        window.setTimeout(function () {
          options.arrowKeys = arrowKeys;
          options.escKey = escKey;
        }, 0);
      }

      place();
      gallery.listen('resize', place);
      document.addEventListener('keydown', guardKeys, true);
      gallery.listen('destroy', function () {
        document.removeEventListener('keydown', guardKeys, true);
        pill.style.top = '';
      });
    },
  };
})();
